import { useCallback, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { isManualEmailError } from "../helpers";
import { type EmailVerificationErrorType } from "../types";

interface UseEmailVerificationInitialStateProps {
  onAuthenticationLinkClick?: () => void;
}

export const useEmailVerificationInitialState = ({
  onAuthenticationLinkClick,
}: UseEmailVerificationInitialStateProps) => {
  const {
    trigger,
    formState: { errors },
    watch,
  } = useFormContext();

  const emailValue = watch("email");

  const handleBlur = useCallback(async () => {
    await trigger("email");
  }, [trigger]);

  const handleAuthenticationClick = useCallback(() => {
    onAuthenticationLinkClick?.();
  }, [onAuthenticationLinkClick]);

  useEffect(() => {
    const validateEmail = async () => {
      // Don't trigger validation if there's a manual error (e.g., from Mailgun validation)
      // This preserves the Mailgun error message

      if (
        errors.email &&
        !isManualEmailError(errors.email.type as EmailVerificationErrorType)
      ) {
        await trigger("email");
      }
    };

    void validateEmail();
  }, [emailValue, trigger, errors.email]);

  return {
    handleBlur,
    handleAuthenticationClick,
  };
};
